import { Fragment, lazy, Suspense } from 'react';
import { isLiveStream } from '@core/livestream/helpers';
const Component = lazy(() => import(/* webpackChunkName: 'lslite' */ './UseLiveStreamingLite'));
/**
 * Lazy loaded component for LiveStreamingLite.
 * @param props
 * @returns
 */
export const UseLiveStreamingLite = (props) => isLiveStream(props.video) ? (<Suspense fallback={<Fragment />}>
      <Component {...props}/>
    </Suspense>) : null;
